module.exports = __webpack_public_path__ + "img/circle-xmark.66e40e55.svg";